import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { Pagination, Autoplay } from "swiper/modules";
import getComments from "../../services/getComments.js";
import API_BASE_URL from "../../config.js";
import { FaMapMarkerAlt } from "react-icons/fa";
import Estrella from "../../assets/Estrella.png"; // Importar imagen de estrella

const Comments = () => {
    const [comments, setComments] = useState([]);
    const BASE_URL = API_BASE_URL.slice(0, -4);

    useEffect(() => {
        const fetchComments = async () => {
            const responseComments = await getComments();
            setComments(responseComments);
        };
        fetchComments();
    }, []);

    return (
        <div className="bg-white p-6 rounded-lg max-w-md mx-auto font-poppins md:max-w-3xl lg:max-w-4xl">
            {/* Título */}
            <h2 className="text-xl font-bold text-primaryP mb-4">Reseñas</h2>

            {/* Slider */}
            <Swiper
                modules={[Pagination, Autoplay]}
                pagination={{ clickable: true }}
                loop={true}
                autoplay={{ delay: 5000, disableOnInteraction: false }}
                className="w-full h-80"
                slidesPerView={1} // En móvil 1
                breakpoints={{
                    768: { slidesPerView: 2, spaceBetween: 20 }, // En escritorio 2 con espacio entre ellos
                }}
            >
                {comments.map((comment, index) => (
                    <SwiperSlide key={index} className="p-6 !h-[260px] bg-gray-50 rounded-lg shadow-md">
                        <div className="flex items-center mb-3">
                            {/* Imagen de perfil */}
                            <img
                                src={`${BASE_URL}${comment.imagen}`}
                                alt={comment.name}
                                className="w-12 h-12 rounded-full border border-gray-300"
                            />

                            {/* Nombre y detalles */}
                            <div className="ml-3">
                                <h3 className="font-semibold text-lg">{comment.name}</h3>

                                {/* Estrellas y ubicación en la misma fila */}
                                <div className="flex items-center text-sm text-gray-600">
                                    <div className="flex mr-2">
                                        {Array.from({ length: Number(comment.score) || 0 }).map((_, i) => (
                                            <img key={i} src={Estrella} alt="Estrella" className="w-4 h-4" />
                                        ))}
                                    </div>
                                    <div className="flex items-center">
                                        <FaMapMarkerAlt className="mr-1 text-xs" />
                                        <span className="text-xs">{comment.place}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Comentario */}
                        <p className="text-gray-700">{comment.description}</p>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default Comments;
